import { component } from 'vue-form-generator';
// import 'vue-form-generator/dist/vfg.css';

import customObjectData from '@/data/custom-object-schema';

export default {
  name: 'CustomObjectEdit',

  components: {
    VueFormGenerator: component,
  },

  data() {
    return {
      customObject: {
        model: customObjectData.model,
        schema: customObjectData.schema,
        formOptions: customObjectData.formOptions,
      },
      permissions: {
        model: customObjectData.permissions.model,
        schema: customObjectData.permissions.schema,
        formOptions: customObjectData.permissions.formOptions,
      },
    };
  },

  methods: {
    submit() {
      console.log('submitting form', this.customObject.model);
    },
    onChange() {
      console.log('save form on change');
    },
  },
};
